// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".awsui_root_12hwc_oboi4_5:not(#\\9){inline-size:100%}.awsui_layout-strut_12hwc_oboi4_9:not(#\\9){inline-size:100%;position:relative;transform:translate3d(0, 0, 0)}\n", ""]);
// Exports
module.exports = exports;
